<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Badges" pageTitle="Badges" />
            <BadgesContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import BadgesContent from '../Badges/BadgesContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'BadgesPage',
    components: {
        MainHeader,
        PageTitle,
        BadgesContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>